import { render } from "./Testimonial.vue?vue&type=template&id=680f5eb8&scoped=true&ts=true"
import script from "./Testimonial.vue?vue&type=script&lang=ts"
export * from "./Testimonial.vue?vue&type=script&lang=ts"

import "./Testimonial.vue?vue&type=style&index=0&id=680f5eb8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680f5eb8"]])

export default __exports__